// Normalizes an image URL for use as an <img> src.
// Dropbox share links are rewritten to their direct-download host; every other
// host (e.g. the Supabase proxy URL) is returned unchanged so it renders as-is.
export function getDirectDropboxImageUrl(dbUrl: string) {
  if (!dbUrl) return ''

  try {
    const url = new URL(dbUrl)

    // If it's already a direct Dropbox URL, return as-is.
    if (url.hostname === 'dl.dropboxusercontent.com') {
      return url.toString()
    }

    // Convert standard Dropbox share links to direct links.
    if (url.hostname === 'www.dropbox.com' || url.hostname === 'dropbox.com') {
      url.hostname = 'dl.dropboxusercontent.com'
      return url.toString()
    }

    // For non-Dropbox hosts, return the original URL unchanged.
    return dbUrl
  }
  catch {
    // Fallback for non-absolute URLs or invalid URL strings.
    if (dbUrl.includes('dl.dropboxusercontent.com')) {
      return dbUrl
    }
    return dbUrl.replace(/www\.dropbox\.com/g, 'dl.dropboxusercontent.com')
  }
}
